import { useQuery } from "@tanstack/react-query";
import { getColors } from "../../api/COLORS/colors";

export const useColors = () => {
    return useQuery({
        queryKey: ['colors'],
        queryFn: getColors,
        staleTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
